// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dMxz3cnynJZPhy {\n  display: inline-block;\n  width: 100%;\n  margin-bottom: 4px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardTileDropDownWrapper": "dMxz3cnynJZPhy"
};
export default ___CSS_LOADER_EXPORT___;
